import { StatusBadge } from '@/components/common/StatusBadge';
import { APPROVAL_STATUS_TONE } from '@/styles/statusColors';
import type { WorkSummaryDcrRow } from '../types/dashboard.types';

type WorkStatus = WorkSummaryDcrRow['status'];

const STATUS_LABEL: Record<WorkStatus, string> = {
  approved: 'Approved',
  rejected: 'Rejected',
  pending: 'Pending',
};

interface WorkStatusBadgeProps {
  status: WorkStatus;
}

export function WorkStatusBadge({ status }: WorkStatusBadgeProps) {
  return <StatusBadge tone={APPROVAL_STATUS_TONE[status]}>{STATUS_LABEL[status]}</StatusBadge>;
}
